export const EMAIL_SOURCE_APP_ID = 'MARKETING_EMAIL_AUTOMATED';
export const SOURCE_APP_IDS_FOR_TRACKING = {
  email: EMAIL_SOURCE_APP_ID
};
export const SIMPLE_AUTOMATION_EMAIL_WORKFLOW_TRIGGERS = ['BOUNCE', 'CLICK', 'SPAMREPORT', 'OPEN', 'DELIVERED', 'REPLIED', 'SENT', 'UNSUBSCRIBED'
// 'OPEN_NOCLICK',
// 'OPEN_NOREPLY',
// 'DELIVERED_NOOPEN',
// 'SENT_NODELIVERED',
];